var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon24Search(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_24_search",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_box",
    "data-name": "Bounding box",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_color",
    "data-name": "Icon color",
    d: "M16.8,18a.5.5,0,0,1-.355-.149l-4-4a2.683,2.683,0,0,1-.3-.361l-.75-1a7.026,7.026,0,0,1-4.37,1.532H7A7.01,7.01,0,0,1,3.974.69a6.991,6.991,0,0,1,8.518,1.971,7.016,7.016,0,0,1-.046,8.753l1,.691a2.471,2.471,0,0,1,.43.35l4,4.005a.5.5,0,0,1-.02.691l-.7.7A.5.5,0,0,1,16.8,18ZM7.025,2a5.008,5.008,0,1,0,5,5.007A5.009,5.009,0,0,0,7.025,2Z",
    transform: "translate(3 3)",
    fill: "#1dbbbe"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Search);
export default __webpack_public_path__ + "static/media/icon_24_search.40c5023c3353395bdc9e5c29a85a0481.svg";
export { ForwardRef as ReactComponent };